import {encryptData, decryptData} from '../../utils/authentication';

// Local Storage Keys
const LS_KEY = {
    user_details: '_user_',
    session: 'session',
    sessionExpiry: 'ses_exp',
};

// Encryption keys
const encKey = process.env.REACT_APP_STORAGE_KEY;
const isDevEnv = process.env.NODE_ENV !== 'production';

const set = {
    userDetails: (data) => {
        localStorage.setItem(
            LS_KEY.user_details,
            isDevEnv
                ? JSON.stringify({user_details: data})
                : encryptData(JSON.stringify({user_details: data}), encKey),
        );
    },
    session: (key) => {
        localStorage.setItem(LS_KEY.session, key);
    },
    sessionExpiry: (date) => {
        localStorage.setItem(LS_KEY.sessionExpiry, date);
    },
};

const fetch = {
    userDetails: () => {
        const data = localStorage.getItem(LS_KEY.user_details);
        if (data) {
            try {
                const decoded = JSON.parse(
                    isDevEnv ? data : decryptData(data, encKey),
                );
                return decoded && decoded.user_details;
            } catch (err) {
                console.log(err);
            }
        }
    },
    session: () => {
        return localStorage.getItem(LS_KEY.session);
    },
    sessionExpiry: () => {
        return localStorage.getItem(LS_KEY.sessionExpiry);
    },
};

const destroy = {
    userDetails: () => {
        localStorage.removeItem(LS_KEY.user_details);
    },
    session: () => {
        localStorage.removeItem(LS_KEY.session);
    },
    sessionExpiry: () => {
        localStorage.removeItem(LS_KEY.sessionExpiry);
    },
};

export const storage = {
    set,
    fetch,
    destroy,
};
